import { createAction, props } from '@ngrx/store';
import { ClubCategory } from './club-category.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records club category'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records club category success', 
    props<{ listData: ClubCategory[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records club category failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record club category',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record club category success', 
    props<{ singleData: ClubCategory }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record club category failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record club category',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record club category success'
);
export const addRecordFailure = createAction(
    '[Data] Add record club category failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record club category',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record club category success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record club category failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record club category',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record club category success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record club category failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state club category',
);